import snarkdown from 'snarkdown';
import LinkifyIt from 'linkify-it';

const linkifyIt = new LinkifyIt();

export const getHTMLFromMarkdown = (markdown: string) => {
  const links = linkifyIt.match(markdown);

  let newMarkdown = markdown;

  if (links?.length) {
    links.forEach((val) => {
      const cleanUrl = val.url.replace(/\\/g, '');
      const newUrl = cleanUrl;

      const lastIndexChar = markdown.charAt(val.lastIndex);
      const fistIndexChar = markdown.charAt(val.index - 1);

      if (
        lastIndexChar !== ')' &&
        lastIndexChar !== ']' &&
        fistIndexChar !== '(' &&
        fistIndexChar !== '['
      ) {
        newMarkdown = newMarkdown.replace(
          val.url,
          `<a target="_blank" rel="nofollow noreferrer" href=${newUrl}>${newUrl}</a>`,
        );
      } else {
        newMarkdown = newMarkdown.replace(val.url, newUrl);
      }
    });
  }

  return snarkdown(newMarkdown)
    .replace(
      /(<a href="(https?:)?\/\/.*?")>/g,
      '$1 target="_blank" rel="nofollow noreferrer">',
    )
    .replace(/<br \/>/g, '<br /><br />');
};
